import React, {useEffect} from "react";
import {useStores} from "../../../stores";
import type {Bag} from "../../../services/classes/Bag";
import {useLocation, useNavigate} from "react-router";
import {FormControl, Select} from "@mui/material";
import {observer} from "mobx-react-lite";
import {SelectDatasetMenu} from "../../_tiny/SelectDatasetMenu";
import Stack from "@mui/material/Stack";
import {environment} from "../../../env.ts";
import {DatabagAdminEditModal} from "~/components/main/header/DatabagAdminEditModal.tsx";

type Props = {
    disabled?: boolean;
    showEmpty?: boolean;
}
export const SelectDataset: React.FC<Props> = observer(({disabled, showEmpty}) => {
    const {bagStore, authStore} = useStores();
    const bag = bagStore.bag as Bag;
    const value = bag?.id || '';
    const location = useLocation();
    const navigate = useNavigate();
    const isStaff = environment.isTest || authStore.isMithraStaffGroup;
    const bags = bagStore.userBagChoices;
    useEffect(() => {
        if (!bags) {
            // TODO: The select-dataset is reloaded when the page is changed, this can be optimized
            //  This component is unloaded when the router changes, pull the component higher up in the route chain
            bagStore.getAllBags()
        }
    }, [bagStore, bags])

    if (bags && !bag) {
        return null;
    }

    return <FormControl variant="standard" className="select-dataset-root" size="small">
        {!bags
            ? <Select
                value=""
                className="select-bag-field is-loading"
                disabled>
            </Select>
            : <Stack direction="row" spacing={2} alignItems="center">
                <SelectDatasetMenu
                    variant="standard"
                    value={value}
                    onChange={event => {
                        const bagId = event.target.value;
                        bagStore.changeBag(bagId, navigate, location);
                    }}
                    // displayEmpty
                    className="select-bag-field"
                    disabled={disabled}
                    bags={bags}
                />
                {
                    isStaff && <DatabagAdminEditModal bag={bag}/>
                }
            </Stack>}
    </FormControl>
})
